module.exports = __webpack_public_path__ + "img/3_ToDust.e9cd3fa6.jpg";